import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "../data/content";

export const Footer = () => {
  return (
    <footer className="bg-forest-dark text-white" data-testid="site-footer">
      <div className="container-px py-20 lg:py-28">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="inline-flex bg-white rounded-[12px] p-2">
              <img src="/kotam-logo.png" alt="Kotam Projects" className="h-14 w-auto" />
            </div>
            <p className="mt-6 max-w-sm text-white/60 leading-relaxed">
              Building spaces that exceed expectations across Victoria and South Australia — with
              craftsmanship, precision, and integrity.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-quote"
              className="mt-8 group inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-semibold text-forest-dark transition-transform hover:-translate-y-0.5"
            >
              Start Your Project
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>

          <div className="lg:col-span-2">
            <h4 className="label text-gold">Explore</h4>
            <ul className="mt-6 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/70 transition-colors hover:text-gold"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="label text-gold">Services</h4>
            <ul className="mt-6 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to="/services" className="text-white/70 transition-colors hover:text-gold">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="label text-gold">Get in Touch</h4>
            <ul className="mt-6 space-y-4 text-white/70">
              <li>
                <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="footer-phone">
                  <Phone className="h-4 w-4 text-gold shrink-0" /> {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-gold transition-colors" data-testid="footer-email">
                  <Mail className="h-4 w-4 text-gold shrink-0" /> {COMPANY.email}
                </a>
              </li>
              {COMPANY.offices.map((o) => (
                <li key={o.state} className="flex items-start gap-3">
                  <MapPin className="h-4 w-4 text-gold shrink-0 mt-1" />
                  <span>
                    <span className="block text-white/40 text-xs uppercase tracking-widest">{o.label}</span>
                    {o.address}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-white/40">© {new Date().getFullYear()} Kotam Projects. All rights reserved.</p>
          <p className="text-sm text-white/40">Licensed Builder · Fully Insured · OH&S Compliant</p>
        </div>
      </div>
    </footer>
  );
};
